import Joi from 'joi';

import { FeatureItemValueTypeEnum } from '../../../base/enums/feature-item-value-type.enum';
import { VehicleFeatureItemTypeEnum } from '../../enums/vehicle-feature-item-type.enum';

/**
 * Schema for record validation.
 * @description This schema is used to validate the record properties when creating or updating the record.
 */
export const vehicleFeatureItemSchema = () =>
	Joi.object({
		// Type
		type: Joi.string()
			.valid(...Object.values(VehicleFeatureItemTypeEnum))
			.required()
			.messages({
				'any.required': 'validations|vehicle-feature-item-type|required',
				'any.only': 'validations|vehicle-feature-item-type|invalid-value',
			}),
		// Value type
		valueType: Joi.string()
			.valid(...Object.values(FeatureItemValueTypeEnum))
			.optional(),
	})
		// Ignore extra fields
		.unknown();
